// DetailsSectionSkeleton.js
import React from 'react';
import { Box, Skeleton, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';

const DetailsSectionSkeleton = () => {
  return (
    <Box sx={{ p: 3, mb: 4 }}>
      <Skeleton variant="text" width="20%" height={40} />
      
      <List dense>
        {[...Array(5)].map((_, index) => (
          <React.Fragment key={index}>
            <ListItem>
              <ListItemIcon>
                <Skeleton variant="circular" width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary={<Skeleton variant="text" width="60%" height={24} />}
                secondary={<Skeleton variant="text" width="40%" height={20} />}
              />
            </ListItem>
            {index < 4 && <Divider variant="inset" component="li" />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default DetailsSectionSkeleton;